import Color from 'color';

export function getDescriptionText(colorSeed: string) {
  const color = Color(colorSeed);
  const rgb = color.object();
  const cmyk = color.cmyk().round().object();

  return `The hexadecimal color ${colorSeed} has RGB values of R: ${rgb.r} , G: ${rgb.g}, B: ${rgb.b} and CMYK values of C: ${cmyk.c}, M: ${cmyk.m}, Y: ${cmyk.y}, K:${cmyk.k}.`;
}

export function xyzToXyy({ x, y, z }: { x: number; y: number; z: number }) {
  const total = x + y + z;

  if (total === 0) {
    return [0, 0, y];
  }

  const xx = x / total;
  const yy = y / total;

  return [xx, yy, y];
}

const eps = 216 / 24389;
const kap = 24389 / 27;
const Xn = 95.047;
const Yn = 100;
const Zn = 108.883;

export function xyzToLuv({ x, y, z }: { x: number; y: number; z: number }): {
  l: number;
  u: number;
  v: number;
} {
  const vR = (9 * Yn) / (Xn + 15 * Yn + 3 * Zn);
  const uR = (4 * Xn) / (Xn + 15 * Yn + 3 * Zn);
  // If XYZ = [0,0,0], avoid division by zero and return conversion
  if (x === 0 && y === 0 && z === 0) {
    return { l: 0, u: 0, v: 0 };
  }

  const v1 = (9 * y) / (x + 15 * y + 3 * z);
  const u1 = (4 * x) / (x + 15 * y + 3 * z);
  const yR = y / Yn;

  const l = yR > eps ? 116 * Math.cbrt(yR) - 16 : kap * yR;
  const u = 13 * l * (u1 - uR);
  const v = 13 * l * (v1 - vR);
  // Add zero to prevent signed zeros (force 0 rather than -0)
  return { l: l + 0, u: u + 0, v: v + 0 };
}

export function xyzToHunterLab({ x, y, z }: { x: number; y: number; z: number }) {
  const sqrtY = Math.sqrt(y);

  const l = 10 * sqrtY;
  const a = 17.5 * ((1.02 * x - y) / sqrtY);
  const b = 7 * ((y - 0.847 * z) / sqrtY);

  return { l, a, b };
}

export function hexColorToBinary(hex: string) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const rBinary = r.toString(2).padStart(8, '0');
  const gBinary = g.toString(2).padStart(8, '0');
  const bBinary = b.toString(2).padStart(8, '0');

  return `${rBinary} ${gBinary} ${bBinary}`;
}
